(function () {
  var redirects = {
    'fine gold collection': '/collections/premier-collection',
    'gold collection': '/collections/premier-collection',
    'fine sterling collection': '/collections/elegance-sterling',
    'fine silver collection': '/collections/elegance-sterling',
    'silver collection': '/collections/elegance-sterling',
    'moissanite collection': '/collections/moissanite-collection',
    'pearl collection': '/collections/pearl-collection',

    'ring': '/collections/all?filter.p.m.custom.type=Ring',
    'rings': '/collections/all?filter.p.m.custom.type=Ring',
    'earring': '/collections/all?filter.p.m.custom.type=Earring',
    'earrings': '/collections/all?filter.p.m.custom.type=Earring',
    'pendant': '/collections/all?filter.p.m.custom.type=Pendant',
    'pendants': '/collections/all?filter.p.m.custom.type=Pendant',
    'inspirational': '/collections/all?filter.p.m.custom.type=Inspirational',

    'diamond': '/collections/all?filter.p.m.custom.gemstones=Diamond',
    'moissanite': '/collections/all?filter.p.m.custom.gemstones=Moissanite',
    'alexandrite': '/collections/all?filter.p.m.custom.gemstones=Alexandrite',
    'ruby': '/collections/all?filter.p.m.custom.gemstones=Ruby',
    'sapphire': '/collections/all?filter.p.m.custom.gemstones=Sapphire',
    'emerald': '/collections/all?filter.p.m.custom.gemstones=Emerald',
    'opal': '/collections/all?filter.p.m.custom.gemstones=Opal',
    'pearl': '/collections/all?filter.p.m.custom.gemstones=Pearl',
    'garnet': '/collections/all?filter.p.m.custom.gemstones=Garnet',
    'amethyst': '/collections/all?filter.p.m.custom.gemstones=Amethyst',
    'aquamarine': '/collections/all?filter.p.m.custom.gemstones=Aquamarine',
    'topaz': '/collections/all?filter.p.m.custom.gemstones=Topaz',
    'tourmaline': '/collections/all?filter.p.m.custom.gemstones=Tourmaline',
    'peridot': '/collections/all?filter.p.m.custom.gemstones=Peridot',
    'spinel': '/collections/all?filter.p.m.custom.gemstones=Spinel',
    'tanzanite': '/collections/all?filter.p.m.custom.gemstones=Tanzanite',
    'onyx': '/collections/all?filter.p.m.custom.gemstones=Onyx',
    'quartz': '/collections/all?filter.p.m.custom.gemstones=Quartz',

    'yellow gold': '/collections/all?filter.p.m.custom.metal=Yellow%20Gold',
    'white gold': '/collections/all?filter.p.m.custom.metal=White%20Gold',
    'silver': '/collections/all?filter.p.m.custom.metal=Silver',
    'platinum': '/collections/all?filter.p.m.custom.metal=Platinum'
  };

  function normalizeSearchTerm(value) {
    return String(value || '').toLowerCase().replace(/\s+/g, ' ').replace(/^\s+|\s+$/g, '');
  }

  function redirectForTerm(term) {
    return redirects[normalizeSearchTerm(term)];
  }

  function getQueryParam(name) {
   var match = window.location.search.match(new RegExp('[?&]' + name + '=([^&]*)'));
    return match ? decodeURIComponent(match[1].replace(/\+/g, ' ')) : '';
  }

  function getFormSearchTerm(form) {
    var input = form.querySelector('input[name="q"], input[type="search"]');
    return input ? input.value : '';
  }

  document.addEventListener('submit', function (event) {
    var form = event.target;
    var action;
    var redirectUrl;
	if (!form || form.tagName !== 'FORM') return;

    action = form.getAttribute('action') || '';
    if (action.indexOf('/search') === -1) return;

    redirectUrl = redirectForTerm(getFormSearchTerm(form));
    if (!redirectUrl) return;

    event.preventDefault();
    window.location.href = redirectUrl;
  }, true);

  if (window.location.pathname === '/search') {
    var redirectUrl = redirectForTerm(getQueryParam('q'));
    if (redirectUrl) {
      window.location.replace(redirectUrl);
    }
  }
})();